import { FormControl } from "@mui/material";
import "./styles.css"
import SelectSysOutline from "../../../../components/selectSysOutline";

export default function MultiSelectFilter({ handleSelected, id, title, border, options, ...props }) {


  return (
    <>
      <p style={{ fontSize: '12px', marginBottom: '2px', color: '#2C4992', weight: '400', font: 'roboto' }}>{title}</p>
        <FormControl size="medium" sx={{ width: "100%" }}>
          <SelectSysOutline
            color="textBlue"
            {...props}
            options={Array.isArray(options) ? options : []}
            multiple
            sx={{
              width: {  width: "100%" },
              "div[role='button']": {
                background: '#00a7e1 !important',
                color: "white"
              }
            }}
            size="medium"
          />
        </FormControl>
    </>
  );
}
